export const TextConstants = {
  POINT_OF_ORIGIN_ADMIN: $localize`:@@constants.rawmaterialorigin:Indicates that any location of this type is one where the raw materials originate from`,
  POINT_OF_ORIGIN_CHIP: $localize`:@@constants.help:This location type is marked as a point of origin, meaning, this is a location where raw materials originate from`,
  SAME_ORG_NAME_ERROR: $localize`:@@constants.organisationnameclash:Cannot be the same as your main organisation name`,
  SAME_AS_ORG_ADDRESS: $localize`:@@constants.sameasorganisationaddress:Same as organisation address`,
  DOCUMENT_NO_CONTENT: $localize`:@@constants.documenthasnocontent:This document has no content`,
  DOCUMENT_TYPE_TOOLTIP_HINT: $localize`:@@documenttypes.help:Determines which type of document this is. E.g. Delivery order, Purchase contract, etc`,
  DOCUMENT_NAME_DUPLICATION_ERROR: $localize`:@@error.namealreadyinuse:Already being used by another document`,
  MAIN_INFORMATION: $localize`:@@constants.maininformation:Main information`,
  ADDITIONAL_INFORMATION: $localize`:@@constants.additionalinformation:Additional information`,
  CERTIFICATES_DOCUMENTS_HINT: $localize`:@@evidencecanbeadded.help:Certificate documents (e.g. scan) can be added in the Documents tab once the main details are saved`,
  SERVICE_UNAVAILABLE: $localize`:@@serviceunavailable.help:Service is unavailable. Please try again later`,
  EDIT_ARCHIVED_RECORD_ERROR: $localize`:@@constants.editingarchivednotallowed:Editing an archived record is not allowed`,
  FILL_REQUIRED_FIELDS: $localize`:@@constants.pleasefillinallrequiredfields:Please fill in all required fields`,
  SESSION_HAS_EXPIRED: $localize`:@@constants.sessionexpired.help:Session has expired. Please, log in again`,
  FILE_NOT_SUPPORTED_ERROR: $localize`:@@shared.filenotsupported:File not supported`,
  MISSING_PARAMETERS: $localize`:@@constants.missingparameters:Missing parameters`,
  EMAIL_OR_PASS_INCORRECT: $localize`:@@constants.emailorpasswordisincorrect:Email or password is incorrect`,
  BACK_TO_ADMIN: $localize`:@@constants.backtoadmin:Back to Admin`,
  BACK_TO_USER_SETTINGS: $localize`:@@constants.backtousersettings:Back to User settings`,
  BACK_TO_INBOX: $localize`:@@constants.backtoinbox:Back to Inbox`,
  BACK_TO_SUPPLY_CHAINS: $localize`:@@constants.backtosupplychains:Back to Supply chains`,
  NAME: $localize`:@@shared.name:Name`,
  DESCRIPTION: $localize`:@@shared.description:Description`,
  REMOVE: $localize`:@@action.constants.remove:Remove`,
  RECORD_DELETED: $localize`:@@shared.recorddeleted:Record deleted`,
  COPIED: $localize`:@@constants.copied:Copied`,
  UNSUPPORTED_RESOURCE_TYPE: $localize`:@@error.constants.unsupportedresourcetype:Unsupported resource type`,
  SAVE: $localize`:@@constants.save:Save`,
  EDIT: $localize`:@@action.edit:Edit`,
  DELETE: $localize`:@@action.delete:Delete`,
  DOWNLOAD: $localize`:@@action.download:Download`,
  ARCHIVE: $localize`:@@shared.archive:Archive`,
  UNARCHIVE: $localize`:@@shared.unarchive:Unarchive`,
  TYPE: $localize`:@@constants.type:Type`,
  COUNTRY: $localize`:@@shared.country:Country`,
  STATUS: $localize`:@@shared.status:Status`,
  ORGANISATION: $localize`:@@shared.organisation:Organisation`,
  TAGS: $localize`:@@constants.tags:Tags`,
  MATERIALS: $localize`:@@shared.materials:Materials`,
  ALLOWED_MATERIALS: $localize`:@@shared.allowedmaterials:Allowed materials`,
  PRODUCT: $localize`:@@constants.product:Product`,
  CREATION_DATE: $localize`:@@shared.creationdate:Creation date`,
  EMAIL: $localize`:@@constants.email:Email`,
  PASSWORD: $localize`:@@constants.password:Password`,
  ISSUANCE_DATE: $localize`:@@constants.issuancedate:Issuance date`,
  VALID_FROM: $localize`:@@constants.validfrom:Valid from`,
  VALID_TO: $localize`:@@constants.validto:Valid to`,
  CATEGORY_HINT: $localize`:@@constants.categpryhint.help:E.g. tree species, alloys, meat, etc.`,
  CATEGORY: $localize`:@@shared.category:Category`,
  LOCATION_TYPES_TOOLTIP: $localize`:@@location-types.help:Determines the type(s) of the location. E.g. Forest, Sawmill, Exporter, Importer, Agent, etc.`,
  MISSING_DOC_TYPES_TOOLTIP: $localize`:@@tooltip.rulesets.documentsmissing:One or more documents are missing that are required by a ruleset(s).`,
  ADD_NEW: $localize`:@@action.addnew:Add new`,
  ADD: $localize`:@@action.add:Add`,
  ADD_ALL: $localize`:@@action.addall:Add all`,
  CLEAR: $localize`:@@constants.clear:Clear`,
  CLOSE: $localize`:@@action.close:Close`,
  ADD_LOCATION: $localize`:@@action.addlocation:Add location`,
  FULL_SCREEN: $localize`:@@shared.fullscreen:Full screen`,
  ZOOM_OUT: $localize`:@@constants.zoomout:Zoom out`,
  ZOOM_IN: $localize`:@@constants.zoomin:Zoom in`,
  REMOVE_CONFIRMATION: $localize`:@@action.constants.removeconfirmation:Remove confirmation`,
  DELETE_CONFIRMATION: $localize`:@@action.constants.deleteconfirmation:Delete confirmation`,
  DELETE_CONFIRMATION_CONTENT: $localize`:@@confirm.deleterecord:Are you sure that you want to delete this record?`,
  ADD_ALL_CONFIRMATION: $localize`:@@action.constants.addallconfirmation:Add all confirmation`,
  UNARCHIVE_CONFIRMATION: $localize`:@@constants.unarchiveconfirmation:Unarchive confirmation`,
  ARCHIVE_CONFIRMATION: $localize`:@@shared.archiveconfirmation:Archive confirmation`,
  UNARCHIVE_CONFIRMATION_TEXT: $localize`:@@confirm.constants.unarchiverecord:Are you sure that you want to unarchive this record?`,
  ARCHIVE_CONFIRMATION_TEXT: $localize`:@@confirm.constants.archiverecord:Are you sure that you want to archive this record?`,
  AREA_HA: $localize`:@@shared.areaha:Area (ha)`,
  ARCHIVED: $localize`:@@constants.archived:Archived`,
  UNARCHIVED: $localize`:@@constants.unarchived:Unarchived`,
  RECORD_DETAILS: $localize`:@@constants.recorddetails:Record details`,
  TEMPLATE_DETAILS: $localize`:@@constants.templatedetails:Template details`,
  CERTIFICATE_DETAILS: $localize`:@@shared.certificatedetails:Certificate details`,
  PRODUCT_DETAILS: $localize`:@@constants.productdetails:Product details`,
  PROCESS_DETAILS: $localize`:@@action.constants.processdetails:Process details`,
  LOCATION_DETAILS: $localize`:@@shared.locationdetails:Location details`,
  DELIVERY_DETAILS: $localize`:@@constants.deliverydetails:Delivery details`,
  DOCUMENT_DETAILS: $localize`:@@constants.documentdetails:Document details`,
  ITEM_DETAILS: $localize`:@@constants.itemdetails:Item details`,
  ORGANISATION_DETAILS: $localize`:@@constants.organisationdetails:Organisation details`,
  MATERIAL_DETAILS: $localize`:@@shared.materialdetails:Material details`,
  COUNTRY_DETAILS: $localize`:@@constants.countrydetails:Country details`,
  ATTACHED_TO: $localize`:@@constants.attachedto:Attached to`,
  UNITS_OF_MEASUREMENT: $localize`:@@constants.unitsofmeasurement:Units of measurement`,
  LOCATION: $localize`:@@shared.location:Location`,
  FIRTS_INPUT_DATE: $localize`:@@shared.firstinputdate:First input date`,
  LAST_OUTPUT_DATE: $localize`:@@shared.lastoutputdate:Last output date`,
  INPUT_SUMMARY: $localize`:@@shared.inputsummary:Input summary`,
  OUTPUT_SUMMARY: $localize`:@@shared.outputsummary:Output summary`,
  WEBSITE: $localize`:@@shared.website:Website`,
  ADDRESS: $localize`:@@shared.address:Address`,
  ZIP_POSTCODE: $localize`:@@shared.zippostcode:ZIP / Postcode`,
  STATE_REGION: $localize`:@@constants.stateregion:State / Region`,
  ACCEPT: $localize`:@@action.accept:Accept`,
  DISCARD_CHANGES_GO_BACK: $localize`:@@constants.discardchangesgoback:Discard changes & go back`,
  DISCARD_CHANGES_LEAVE: $localize`:@@constants.discardchangesleave:Discard changes & leave`,
  CANCEL: $localize`:@@shared.cancel:Cancel`,
  CONTINUE: $localize`:@@shared.continue:Continue`,
  EXIT_CONFIRMATION: $localize`:@@constants.exitconfirmation:Exit confirmation`,
  DEACTIVATE: $localize`:@@action.constants.deactivate:Deactivate`,
  ACTIVATE: $localize`:@@action.constants.activate:Activate`,
  LOCATION_TYPES: $localize`:@@shared.locationtypes:Location types`,
  GEOLOCATION: $localize`:@@shared.geolocation:Geolocation`,
  OPTIONAL: $localize`:@@constants.optional:Optional`,
  NOTE: $localize`:@@constants.note:Note`,
  RANGE_FROM_TO: $localize`:@@shared.rangefromto:Range (from/to)`,
  SELECTED_QTY: $localize`:@@constants.selectedqty:Selected q-ty`,
  INITIAL_QTY: $localize`:@@constants.initialqty:Initial q-ty`,
  VOLUME_M3: $localize`:@@shared.volumem3:Volume (m3)`,
  NET_MASS_KG: $localize`:@@shared.netmasskg:Net mass (kg)`,
  PRODUCER_COUNTRY: $localize`:@@constants.producercountry:Producer country`,
  PRODUCER_NAME: $localize`:@@constants.producername:Producer name`,
  CERTIFICATES: $localize`:@@constants.certificates:Certificates`,
  DOCUMENTS: $localize`:@@constants.documents:Documents`,
  SHARES: $localize`:@@constants.shares:Shares`,
  COMMENTS: $localize`:@@constants.comments:Comments`,
  RISK_ASSESSMENT_REPORTS: $localize`:@@constants.riskassessmentreports:Risk assessments`,
  REFERENCED_RISK_ASSESSMENT_REPORTS: $localize`:@@constants.referencedriskassessmentreports:Referenced risk assessments`,
  ITEMS: $localize`:@@constants.items:Items`,
  DELIVERIES: $localize`:@@constants.deliveries:Deliveries`,
  PROCESSES: $localize`:@@constants.processes:Processes`,
  LOCATIONS: $localize`:@@constants.locations:Locations`,
  ORGANISATIONS: $localize`:@@shared.organisations:Organisations`,
  SUPPLY_CHAIN: $localize`:@@constants.supplychain:Supply chain`,
  GPS_DATA: $localize`:@@constants.gpsdata:GPS data`,
  INPUTS: $localize`:@@constants.inputs:Inputs`,
  OUTPUTS: $localize`:@@constants.outputs:Outputs`,
  INDICATORS: $localize`:@@constants.indicators:Indicators`,
  RELATED_PRODUCTS: $localize`:@@constants.relatedproducts:Related products`,
  ANALYSES: $localize`:@@constants.analyses:Analyses`,
  LINKED_LOCATIONS: $localize`:@@constants.linkedlocations:Linked locations`,
  PRODUCT_SUMMARY: $localize`:@@constants.productsummary:Product summary`,
  EUDR_DDS: $localize`:@@constants.eudrdds:EUDR DDS`,
  DOCUMENT_TYPE: $localize`:@@shared.documenttype:Document type`,
  MATERIAL: $localize`:@@constants.material:Material`,
  DELIVERY: $localize`:@@constants.delivery:Delivery`,
  VALID_UNTIL: $localize`:@@shared.validuntil:Valid until`,
  RULESET: $localize`:@@constants.ruleset:Ruleset`,
  PRODUCTS: $localize`:@@constants.products:Products`,
  REMAINING_QTY: $localize`:@@constants.remainingqty:Remaining q-ty`,
  CREATED_AT_LOCATION: $localize`:@@shared.createdatlocation:Created at location`,
  CURRENT_LOCATION: $localize`:@@shared.currentlocation:Current location`,
  SEARCH: $localize`:@@search-and-filters.search:Search`,
  DEFAULT_ERROR_NOTIFICATION: $localize`:@@error.unexpectederror:An unexpected error happened. Please try again later`,
  DEFAULT_SUCCESS_NOTIFICATION: $localize`:@@notification.defaultsuccess:Success`,
  PURCHASE_ORDERS: $localize`:@@purchase.orders:Purchase orders`,
  PURCHASE_ORDER_DETAILS: $localize`:@@constants.purchaseorderdetails:Purchase order details`,
  DATE_COMPLETED: $localize`:@@shared.datecompleted:Date completed`,
  RESIDUAL_RISK: $localize`:@@shared.residualrisk:Residual risk`,
  CALCULATED_RISK: $localize`:@@shared.calculatedrisk:Calculated risk`,
  NAME_ID: $localize`:@@ui.nameid:Name / ID`,
  RISK_PRESENT_MITIGATED: $localize`:@@label.riskpresentmitigated:Risk present (mitigated)`,
  PURCHASE_ORDER: $localize`:@@shared.purchase.order:Purchase order`,
  NUMBER_ID: $localize`:@@shared.numberid:Number / ID`,
  OPEN_CALENDAR: $localize`:@@shared.opencalendar:Open calendar`,
  ITEM_ID_NUMBER: $localize`:@@shared.itemidnumber:Item ID / number`,
  MAIN_MEASUREMENT_TYPE: $localize`:@@constants.mainmeasurementtype:Main measurement type`,
  NUMBER: $localize`:@@shared.number:Number`,
  QUANTITY: $localize`:@@shared.quantity:Quantity`,
  TITLE: $localize`:@@shared.title:Title`,
  LABEL: $localize`:@@shared.label:Label`,
  COMMON_NAME: $localize`:@@shared.commonName:Common name`,
  SCIENTIFIC_NAME: $localize`:@@shared.scientificName:Scientific name`,
  ORGANISATION_CREATED: $localize`:@@shared.organisationcreated:Organisation created`,
  HS_CODE: $localize`:@@shared.hscode:HS code`,
  HS_CODE_HINT: $localize`:@@product-overlay.hscodehint:An HS code, or Harmonized System code, is a standardized six-digit numerical code used internationally to classify products for trade purposes, facilitating customs procedures and trade statistics.`,
  CONFIRMATION: $localize`:@@shared.confirmation:Confirmation`,
};
